import React from "react";
import { useTranslation } from "react-i18next";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ButtonMAS from "ButtonMAS/ButtonMAS";
import s from "./SearchFieldButtonBar.module.scss";

const SearchFieldButtonBar = ({
  loading,
  collapse,
  handleCollapse,
  resetBtn,
  handleReset,
  searchBtn,
  handleSearch,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s.searchFieldBtnBar}>
      {
        <div style={{ display: collapse != undefined ? "block" : "none" }}>
          {collapse ? (
            <ButtonMAS
              variant="bordered"
              endIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
              onClick={() => handleCollapse(false)}
            >
              {t("component.searchField.title.expand")}
            </ButtonMAS>
          ) : (
            <ButtonMAS
              variant="bordered"
              endIcon={<ExpandLessIcon sx={{ fontSize: 18 }} />}
              onClick={() => handleCollapse(true)}
            >
              {t("component.searchField.title.collapse")}
            </ButtonMAS>
          )}
        </div>
      }

      <div></div>

      <div className={s.resetSearchButtonContainer}>
        {resetBtn && (
          <ButtonMAS
            variant="secondary"
            onClick={handleReset}
            disabled={loading}
          >
            {t("component.searchField.title.reset")}
          </ButtonMAS>
        )}
        {searchBtn && (
          <ButtonMAS
            onClick={() => handleSearch("search")}
            disabled={loading}
          >
            {t("component.searchField.title.search")}
          </ButtonMAS>
        )}
      </div>
    </div>
  );
};

export default React.memo(SearchFieldButtonBar);
